import React from 'react';

import {
  FaCar,
  FaCog,
  FaIndustry,
  FaShoppingCart,
  FaTree,
  FaTruck,
  FaUtensils,
} from 'react-icons/fa';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useTranslation } from 'react-i18next';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './style.css';

const PartnersCategory = () => {
  const { t } = useTranslation();

  const categories = [
    {
      key: 'ecommerce',
      icon: FaShoppingCart,
      name: t('partnersCategory.categories.ecommerce'),
    },
    {
      key: 'logistics',
      icon: FaTruck,
      name: t('partnersCategory.categories.logistics'),
    },
    {
      key: 'production',
      icon: FaIndustry,
      name: t('partnersCategory.categories.production'),
    },
    {
      key: 'gastronomy',
      icon: FaUtensils,
      name: t('partnersCategory.categories.gastronomy'),
    },
    {
      key: 'automotive',
      icon: FaCar,
      name: t('partnersCategory.categories.automotive'),
    },
    {
      key: 'rotomoulding',
      icon: FaCog,
      name: t('partnersCategory.categories.rotomoulding'),
    },
    {
      key: 'wood',
      icon: FaTree,
      name: t('partnersCategory.categories.wood'),
    },
  ];

  return (
    <section className='PartnersCategory'>
      <div className='PartnersCategory__container'>
        <h2 className='PartnersCategory__title' data-aos='fade-up'>
          {t('partnersCategory.title')}
        </h2>

        <div className='PartnersCategory__slider' data-aos='fade-up'>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
            }}
            className='PartnersCategory__swiper'
          >
            {categories.map((category) => {
              const IconComponent = category.icon;
              return (
                <SwiperSlide key={category.key}>
                  <div className='PartnersCategory__card'>
                    <div className='PartnersCategory__icon'>
                      <IconComponent />
                    </div>
                    <h3 className='PartnersCategory__name'>{category.name}</h3>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default PartnersCategory;
